<template>
    <content-view class="companyOrderDetial">
        <div slot="header" class="ml16 companyOrderDetial-title">
            <h1>{{dataDetail.couponName}}</h1>
            <div class="flex flex-space-between">
                <section class="flex flex-start">
                    <span>创建用户：</span><span>{{dataDetail.createUser}}</span><br>
                    <span class="ml16">创建时间：</span><span>{{dataDetail.createTime}}</span>
                </section>
                <a-button type="primary" @click="toCreateOrder">创建订单</a-button>
            </div>
            <a-card
                :bordered="false"
                :tabList="tabListNoTitle"
                :activeTabKey="noTitleKey"
                @tabChange="key => onTabChange(key,'noTitleKey')"
                class="mt16"
                >
            </a-card>
        </div>
        <div style="companyOrderDetial-content" v-if="noTitleKey==1">
            <a-spin :spinning="spinning">
                <exchange-account :bordered="false" title="兑换统计" :dataDetail="dataDetail" />
                <exchange-outline :bordered="false" title="兑换概要" :dataDetail="dataDetail"/>
                <exchange-goods class="mt24" :bordered="false" title="商品信息" :goodsDetail="dataDetail" :goodsId="dataDetail.goodId" :goodsType="dataDetail.goodCategory" />
            </a-spin>
        </div>
        <div style="companyOrderDetial-content" v-if="noTitleKey==2">
            <a-card>
                <div class="companyOrderDetial-content-title mb24 flex flex-space-between">
                    <span>团购销售订单</span>
                    <a-button type="primary" @click="exportOrder">导出</a-button>
                </div>
                <a-table
                    :bordered="true"
                    :dataSource="dataSource"
                    :columns="columns"
                    :scroll="{ x: 800 }" 
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="(record,index) => index"
                >
                    <span slot="goodCategory" slot-scope="goodCategory">{{['','线上票','线下票','优惠券','储值'][goodCategory]}}</span>
                    <span slot="consumerType" slot-scope="consumerType">{{['','政府','企业','学校','其他'][consumerType]}}</span>
                    <span slot="saleType" slot-scope="saleType">{{['赠送','后付费','预付费'][saleType]}}</span>
                    <span slot="saleTotal" slot-scope="a,item">{{$utils.toFixed(a,2)}}</span>
                    <span slot="action" slot-scope="a,row">
                        <a v-if="getBtnByAuth('couponNewDetail')" class="text-primary" @click="toOrderDetail(row.id)">查看</a>
                    </span>
                </a-table>
            </a-card>
        </div>
    </content-view>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import exchangeGoods from '../../components/modules/change-code/exchange-goods.component';
import exchangeAccount from '../../components/modules/change-code/exchange-account.component';
import exchangeOutline from '../../components/modules/change-code/exchange-outline.component';
export default {
    name: "companyOrderDetial",
    components: {
        exchangeGoods,
        exchangeAccount,
        exchangeOutline
    },
    props: {},
    data() {
        const tabListNoTitle = [
            {
                key: '1',
                tab: '概览'
            },
            {
                key: '2',
                tab: '团购订单'
            },
        ]
        const columns = [
            {
                title: "订单号",
                dataIndex: "id",
            },
            {
                title: '客户名称',
                dataIndex: 'consumerName'
            },
            {
                title: '客户类型',
                dataIndex: 'consumerType',
                scopedSlots: { customRender: "consumerType" }
            },
            {
                title: '销售类型',
                dataIndex: 'saleType',
                scopedSlots: { customRender: "saleType" }
            },
            {
                title: '商品分类',
                dataIndex: 'goodCategory',
                scopedSlots: { customRender: "goodCategory" }
            },
            {
                title: '销售数量',
                dataIndex: 'saleNum',
            },
            {
                title: '订单金额',
                dataIndex: 'saleTotal',
                scopedSlots: { customRender: "saleTotal" }
            },
            {
                title: '销售人员',
                dataIndex: 'saleMan',
            },
            {
                title: '销售门店',
                dataIndex: 'saleShopName',
                scopedSlots: { customRender: "saleShopName" }
            },
            {
                title: '销售日期',
                dataIndex: 'saleDate',
            },
            {
                title: '操作',
                dataIndex: 'action',
                scopedSlots: { customRender: "action" }
            },
        ];
        return {
            spinning: false,
            columns,
            noTitleKey: '1',
            tabListNoTitle: tabListNoTitle,
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 10
            },
            goodsId: 0,
            shopList: [],
            dataDetail: {},
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    watch: {
        shopId(val) {
            if (!val || !this.shopId) return;
            this.getGroupOrders();
        }
    },
    methods: {
        /**
         * @getShopList 获取门店列表
        */
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                res.forEach((item,index) => {
                    item.label = item.name;
                    item.value = item.id;
                });
                this.shopList = [
                    {
                        label: "总部",
                        value: -1,
                    },
                    ...res
                ];
                this.getGoodDetail();
                this.getGroupOrders();
            });
        },
        toCreateOrder() {
            this.$router.push({name: "companyOrderCreate", query: {id: this.goodsId}})
        },
        onTabChange(noTitleKey) {
            this.noTitleKey = noTitleKey
        },
        changePage(page) {
            this.pagination.pageSize = page.pageSize;
            this.pagination.current = page.current;
            this.getGroupOrders();
        },
        toOrderDetail(id) {
            this.$router.push({
                name: "exchangeGroupDetail",
                query: {orderId: id, showDetail: 1}
            });
        },
        getGroupOrders() {
            if (!this.shopId) return;
            this.$api.changeCode.couponGroupOrder({
                body: {
                    pageNum: this.pagination.current,
                    pageSize: this.pagination.pageSize,
                    shopId: this.shopId,
                    couponId: this.goodsId,
                }
            })
            .then(res => {
                res.list.forEach( el => {
                    let shops = this.shopList.find(shop => shop.value == el.saleShopId);
                    if (shops) {
                        el.saleShopName = shops.label;
                    } else {
                        el.saleShopName = "-";
                    }
                })
                this.pagination.total = res.total;
                this.dataSource = res.list;
            });
        },
        getGoodDetail() {
            this.$api.changeCode.exchangeGiftDetails({
                query:  {
                    id: this.goodsId,
                }
            })
            .then(res => {
                this.dataDetail = res;
            });
        },
        exportOrder() {
            this.$api.changeCode.exportCouponGroupOrder({
                query:  {
                    couponId: this.dataDetail.couponId,
                }
            },
            {
                responseType: "blob"
            })
            .then(res => {
                let a = document.createElement("a");
                let blob = new Blob([res.data], {
                    // type: "application/vnd.ms-excel"
                    type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });

                this.downloadUrl = window.URL.createObjectURL(blob);

                let name = "团购销售订单" + '-' + this.$moment().format('YYYY/MM/DD') + '.xlsx'

                a.setAttribute("href", this.downloadUrl);

                var reportName = decodeURI(name);

                a.setAttribute("download", reportName);
                a.click();
            });
        }
    },
    created() {
        this.goodsId = this.$route.query.id;
    },
    mounted() {
        this.getShopList();
    }
}
</script>
<style lang="scss">
.companyOrderDetial {
    &-title {
        h1 {
            font-size: 24px;
        }
        section {
            span:nth-of-type(n) {
                font-size: 14px;
                color: rgba(0,0,0,0.85);
            }
            span:nth-of-type(2n) {
                font-size: 14px;
                color: rgba(0,0,0,0.65);
            }
        }
    }
    &-content {
        &-title {
            font-size: 16px;
            font-weight: 500;
            color: #000;
        }
    }
}
</style>